export enum eBillingMethods
{
    eNone,
    eAdvise,
    eCoreBilling,
    eIntegratedBillingModule
}